import { render, staticRenderFns } from "./ArtistItems.vue?vue&type=template&id=32ec6024&scoped=true"
import script from "./ArtistItems.vue?vue&type=script&lang=js"
export * from "./ArtistItems.vue?vue&type=script&lang=js"
import style0 from "./ArtistItems.vue?vue&type=style&index=0&id=32ec6024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec6024",
  null
  
)

export default component.exports